<ng-container *ngFor = "let list of recursiveList | keyvalue; let i=index">
  <ul *ngIf='ignoredKeys.indexOf(list.key) == -1'>
    <li *ngIf='list.value !== null'>
      {{mapKey(list.key)}}
      <ng-container *ngIf='isObject(list.value)'>
        <app-recursive-comp [recursiveList]="list.value" [documentType]='documentType' [ignoredKeys]='ignoredKeys'></app-recursive-comp>
      </ng-container>
      <ng-container *ngIf='!isObject(list.value)'>
        : {{list.value ? list.value : "-"}}
      </ng-container>
    </li>
  </ul>
</ng-container>
